export const PATHS = {
  main: "/",
  vacancies: "/vacancies",
  vacancyResume: "vacancies/:id",
  detailCourse: "course/:slug",
  detailTechnology: "/technology/:slug",
  aboutUs: "/aboutUs",
  FAQ: "/faq/",
  advantages: "/advantages",
  mapSite: "/mapSite",
  news: "/news",
  newsDetails: "/news/:id",
  technology: "/technology",
  course: "/course",
  allcourses: "/allcourses",
  privacy: "/privacy-policy",
  afterCourses: "/after-courses",
  cookiesPolicy: "/cookies-policy",
  cryptoCourse: "/crypto-course",
  // устаревший адрес, только редирект на cryptoCourse
  cryptoCourseAccess: "/crypto-course/access",
  binanceGeeks: "/binance-x-geeks",
  binanceScenario: "/binance-x-geeks/scenario",
  // Geeks PRO
  careerCenter: "/geeks-pro",
  signIn: "/sign-in",
  signUp: "/sign-up",
  passwordRecovery: "/password_recovery",
  editStudent: "/edit-student",
  direction: "/direction",
  students: "/students/:slug",
  student: "/student/:slug/:id",
  // Geeks junior
  geeksJunior: "/geeks-junior",
};

export const BASE_URL = process.env.REACT_APP_BASE_URL;

// Даты стартов курсов на сайте скрыты. Чтобы вернуть — поставить true.
export const SHOW_COURSE_START = false;

// Client ID для OAuth Google: публичное значение, подставляется при сборке.
// Если его нет, кнопка входа через Google не рисуется — см. components/AuthRedesign/GoogleButton.
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID ?? "";

export const REQUEST_STATUSES = {
  NOT_REQUESTED: "notRequested",
  REQUESTED: "requested",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
  LOADING: "loading",
};

export const BITRIX = {
  test: "https://geeks.bitrix24site.ru/crm_form_lafsj/",
  laptops: "https://geeks.bitrix24site.ru/crm_form_hawxo/",
  trialLesson: "https://geeks.bitrix24site.ru/crm_form_ebvu8/",
  course: "https://geeks.bitrix24site.ru/crm_form_85mqv/",
  anchor: "https://geeks.bitrix24site.ru/crm_form/",
  geeksPro: "https://geeks.bitrix24site.ru/crm_form_7u5vk/",
};

export const externalRecourse = { geekstudio: "https://geekstudio.kg/" };

// Learning platform (Binance course). Staging URL comes from .env,
// production fallback is used when the variable is not set.
export const ONLINE_PLATFORM_URL =
  process.env.REACT_APP_ONLINE_PLATFORM_URL ?? "https://online.geeks.kg";

export const emailsFooter = {
  forTraining: "office@geeks.kg",
  forPartners: "marketing@geeks.kg",
  forInternship: "pro@geeks.kg",
};
